import React from 'react';
import { observer } from 'mobx-react';
import '../../lib/gantt';
import '../../lib/gantt/css/gantt.less';
import ToolBar from './ToolBar';
import TasksEditHead from './TasksEditHead';
import { WeaTab,WeaDialog,WeaLocaleProvider } from 'ecCom';
import TaskInfo from './TaskInfo';
import { Spin,Button } from 'antd';
import { ganttProps } from '.';
import LitterTool from './LitterTool';
import DeleteConfirmDialog from './dialog/DeleteConfirmDialog';
import AdvancedSearchs from '../list/AdvancedSearchs';
const getLabel = WeaLocaleProvider.getLabel;


@observer
export default class GanttContainer extends React.Component<ganttProps, any>{

    constructor(props) {
        super(props);
        this.state = { showSearchAd: false};
    }

    render() {
        const { ganttStore } = this.props;
        const { getGanttId } = ganttStore;
        return <Spin ecId={`${this && this.props && this.props.ecId || ''}_Spin@xrd8sb`} spinning={ganttStore.loading||!ganttStore.isInit} style={{ height: '400px' }}>
            <div className="cube_gantt">
                <TaskInfo ecId={`${this && this.props && this.props.ecId || ''}_TaskInfo@mb7570`} ganttStore={ganttStore}></TaskInfo>
                <LitterTool ecId={`${this && this.props && this.props.ecId || ''}_LitterTool@3y0egy`} ganttStore={ganttStore}></LitterTool>
                <div>

                    <div id={`workSpace_${getGanttId}`}>
                        <div className="TWGanttArea" style={{ overflow: 'hidden', position: 'relative' }}>
                        <div className="dthead">            
                            <TasksEditHead ecId={`${this && this.props && this.props.ecId || ''}_TasksEditHead@wvvvsx`} ganttStore={ganttStore} />
                
                                <WeaTab ecId={`${this && this.props && this.props.ecId || ''}_WeaTab@ain80x`} searchType={['advanced']}
                                    showSearchAd={this.state.showSearchAd}
                                    setShowSearchAd={bool => {
                                        this.setState({
                                            showSearchAd: bool
                                        })
                                    }}
                                    replaceLeft={[
                                        <div>
                                        <ToolBar ecId={`${this && this.props && this.props.ecId || ''}_ToolBar@npxru1`} ganttStore={ganttStore} />
                                        </div>
                                    ]}
                                    buttonsAd={[
                                        (<Button ecId={`${this && this.props && this.props.ecId || ''}_Button@rp5qem@doSearch`} type="primary" onClick={ganttStore.doSearch}>{getLabel(387355, "搜索")}</Button>),
                                        (<Button ecId={`${this && this.props && this.props.ecId || ''}_Button@g12rco@reset`} type="ghost" onClick={() => {ganttStore.form.reset()}}>{getLabel(2022, "重置")}</Button>),
                                        (<Button ecId={`${this && this.props && this.props.ecId || ''}_Button@3onffp@showSearchAd`} type="ghost" onClick={() => {this.setState({showSearchAd: false})}}>{getLabel(201, "取消")}</Button>)
                                    ]}
                                    searchsAd={<AdvancedSearchs ecId={`${this && this.props && this.props.ecId || ''}_AdvancedSearchs@nwnslq`} form={ganttStore.form} conditioninfo={ganttStore.conditionInfo}  quickSearch={ganttStore.doSearch} />}
                                    onChange={() => { }}
                                />
                            </div>
                            <div className="splitterContainer" style={ganttStore.isInit ? { visibility: 'visible' } : { visibility: 'hidden' }}>

                            </div>
                        </div>
                    </div>

                </div>
                <WeaDialog ecId={`${this && this.props && this.props.ecId || ''}_WeaDialog@atfnug`}
                    onCancel={() => { ganttStore.cardDiag_visible = false }}
                    visible={ganttStore.cardDiag_visible}
                    style={{ width: window.innerWidth - 50, height: window.innerHeight - 60 }}
                    hasScroll
                    url={ganttStore.cardDiag_url}
                />
                <DeleteConfirmDialog ecId={`${this && this.props && this.props.ecId || ''}_DeleteConfirmDialog@1au8ur`} ganttStore={ganttStore}></DeleteConfirmDialog>
            </div>
        </Spin>
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/gantt/GanttContainer.tsx